import React from 'react';
import { inject } from 'mobx-react';

@inject('store')
class Authentication extends React.PureComponent<any, any> {
    public constructor(props: any) {
        super(props);
        this.state={
            isShowPage:false
        }
        this.hasLogin();
    }
    render() {
        const { isShowPage } =this.state;
        return isShowPage ? this.props.children : <p style={{fontSize:16,marginTop:15,marginLeft:8,color:'#000'}}>加载中...</p>;
    }
    public hasLogin = () => {
        this.props.store.hasLoginManage((hasLogin) => {
            if (
                !hasLogin &&
                window.location.pathname.toLowerCase() !== '/login'
            ) {
                window.location.href = '/login';
            } else {
                this.setState({
                    isShowPage: true,
                });
            }
        });
    };
}
export default Authentication;